export default {
  root: {
    display: 'flex',
    flex: 1,
    backgroundColor: 'background.light',
  },
  main: {
    flex: 1,
  },
};
